(function () {
	document.addEventListener('shopify:section:load', function () {
		const slider = new Swiper('.js-media-list', getSliderSettings);

		const subSlider = new Swiper('.js-media-sublist', getSubSliderProductSettings);

		setTimeout(function () {
			slider.update();
			subSlider.update();
		}, 100)
	});
})();
document.addEventListener('DOMContentLoaded', function () {
  const mediaList = document.querySelector('.product__media-main-list');
  if (!mediaList) return;

  const allMediaItems = Array.from(mediaList.children);
  
  document.querySelectorAll('input[type="radio"][name^="Couleur"]').forEach(input => {
    input.addEventListener('change', () => {
      const selectedValue = input.value.toLowerCase();

      const targetImage = allMediaItems.find(item =>
        item.querySelector(`img[src*="${selectedValue}"]`)
      );

      if (targetImage) {
        const clone = targetImage.cloneNode(true);
        const featured = mediaList.querySelector('.product__media-item');

        // Remplace uniquement l'image affichée au centre
        if (featured && featured.parentElement) {
          featured.parentElement.replaceChild(clone, featured);
        }
      }
    });
  });
});
